import { render, staticRenderFns } from "./FansList.vue?vue&type=template&id=f16b9b48&scoped=true"
import script from "./FansList.vue?vue&type=script&lang=js"
export * from "./FansList.vue?vue&type=script&lang=js"
import style0 from "./FansList.vue?vue&type=style&index=0&id=f16b9b48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16b9b48",
  null
  
)

export default component.exports